import React, { Component } from 'react';
import { connect } from 'react-redux';
import LANGUAGES_CONTROLLER from '../../../controllers/languages';
import Logger, {LOG_LEVELS} from '../../../utils/logger';

const log = new Logger('PDF_DATA_URI_VIEWER', LOG_LEVELS.DEBUG);
class PdfDataUriViewer extends Component {
  render() {
    log.debug('render(): ', this.props);
    return (
      <div>
        {this.props.dataUri ?
          (<object data={this.props.dataUri} type="application/pdf" width="100%" height="1150px" />)
          :
          (<div>Waiting for document data uri...</div>) }
      </div>
    );
  }

}

// Which props do we want to inject, given the global state?
function mapStateToProps(state) {
  log.debug('mapStateToProps: ', state);
  return {
    languages: state.languages
  };
}



// Wrap the component to inject dispatch and state into it
export default connect(mapStateToProps)(PdfDataUriViewer);